const SET_USER = (state, payload) => {
	state.user = payload
}

const RESET_USER = (state) => {
	state.user = null
}

const RESET_SIGN_IN_FORM = (state) => {
	state.sign_in_form = {
        email: null,
        password: null
    }
}

const RESET_CHANGE_PASSWORD_FORM = (state) => {
	state.change_password_form = {
        old_password: null,
        new_password: null,
		confirm_new_password: null
    }
}

export {
    SET_USER,
    RESET_USER,
    RESET_SIGN_IN_FORM,
    RESET_CHANGE_PASSWORD_FORM
}